const baseInfoFormatConvertor = (baseInfo) => {
  return {
    'name': baseInfo.campaignName,
    'campaign_name': baseInfo.campaignName,
    'client_id': baseInfo.clientId,
    'client_name': baseInfo.clientName,
    'agency_id': baseInfo.agencyId,
    'agency_name': baseInfo.agencyName
  }
}

export { baseInfoFormatConvertor }
